import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { HeroContentModel } from '../../batman-data.service'
import { LiveEventHeader } from 'src/app/funnel/signup/signup.interface'
import { UserAgentService } from 'src/app/singleton-services/user-agent.service'

@Component({
  selector: 'flo-landing-hero',
  templateUrl: './landing-hero.component.html',
  styleUrls: ['./landing-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingHeroComponent {
  constructor(private userAgentService: UserAgentService) {}

  @Input() heroContent: HeroContentModel
  @Input() bgPosition?: string
  @Input() liveEventHeader?: LiveEventHeader
  @Output() signUpButtonClicked = new EventEmitter<void>()

  public isMobile = this.userAgentService.userAgent.isMobile

  handleClick(): void {
    this.signUpButtonClicked.emit()
  }
}
